export default __webpack_public_path__ + "static/setup-config-import-opps-custom-field-04b4b3c7f86519bf6edabf201f897d7f.mp4";